import PropTypes from "prop-types";
import Pin from "assets/pin.svg";
import PinSelected from "assets/pinSelected.svg";
import Text from "components/Common/Text";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";

import { motion } from "framer-motion";

import "./style.css";

export default function EditTeesList({
  teesData,
  onSelectTee,
  activeTeeId,
  isLoading,
}) {
  return (
    <div
      style={{
        padding: 28,
      }}
    >
      {isLoading && <ActivityIndicator />}

      <motion.div layoutId="underline">
        {teesData?.map((i) => (
          <TeeButton
            key={i.uid}
            teeName={i.teeName}
            raing={i.raing}
            slope={i.slope}
            onTeeClick={() => onSelectTee(i)}
            selected={i.teeId === activeTeeId}
          />
        ))}
      </motion.div>
    </div>
  );
}

EditTeesList.propTypes = {
  activeTeeId: PropTypes.string.isRequired,
  onSelectTee: PropTypes.func.isRequired,
  teesData: PropTypes.arrayOf([PropTypes.any]),
  isLoading: PropTypes.bool,
};

EditTeesList.defaultProps = {
  isLoading: false,
  teesData: null,
};

function TeeButton({ teeName, raing, slope, onTeeClick, selected }) {
  return (
    <div
      aria-hidden
      style={{
        backgroundColor: selected ? "#379FDC" : "white",
        borderRadius: 16,
        padding: "16px 0px",
        marginBottom: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: 20,
        paddingRight: 20,
      }}
      onClick={() => onTeeClick()}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        <img src={selected ? PinSelected : Pin} alt="pin icon" />
        <Text
          as="H3"
          bold
          style={{ color: selected ? "white" : "#232C2E", marginLeft: 6 }}
        >
          {teeName}
        </Text>
      </div>
      <div>
        <Text as="P3" bold style={{ color: selected ? "white" : "#8E9191" }}>
          CR {raing} • Slope {slope}
        </Text>
      </div>
    </div>
  );
}

TeeButton.propTypes = {
  onTeeClick: PropTypes.func.isRequired,
  raing: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  slope: PropTypes.number.isRequired,
  teeName: PropTypes.string.isRequired,
};
